import React, { useContext } from "react";
import { HashLink as Link } from "react-router-hash-link";
import { isNil } from "ramda";

import { AffinityFormContext } from "affinityForm";
import { ExecuteButton } from "affinityForm/components/executeButton";
import { Summary } from "affinityUI/data/summary";
import { Button, ButtonVariants } from "affinityUI/elements/button";
import { Card } from "affinityUI/elements/card";
import { VisuallyHidden } from "affinityUI/elements/visuallyHidden";
import { ButtonGroup, FieldLabel } from "affinityUI/form/components";
import { RoleInfo } from "types";

import { UserInfoType } from "../types";

export const UserConfirmation: React.FC<{
  roles: RoleInfo[];
  onCancel: () => void;
}> = ({ roles, onCancel: handleCancel }) => {
  const formContext = useContext(AffinityFormContext);
  const userInfo = formContext?.formData as Maybe<UserInfoType>;
  const userRole = roles.find(({ id }) => id === userInfo?.roleId);

  if (isNil(userInfo)) {
    return <>Error...</>;
  }

  return (
    <Card>
      <Summary.Section
        title="User Information"
        actions={
          <Link to="..#user-information">
            Edit <VisuallyHidden>User Information</VisuallyHidden>
          </Link>
        }
      >
        <Summary.List>
          <Summary.Item label="First name">{userInfo.firstName}</Summary.Item>
          <Summary.Item label="Last name">{userInfo.lastName}</Summary.Item>
          <Summary.Item label="Email">{userInfo.email}</Summary.Item>
        </Summary.List>
      </Summary.Section>
      <Summary.Section
        title="Access control"
        actions={
          <Link to="..#access">
            Edit <VisuallyHidden>Access control</VisuallyHidden>
          </Link>
        }
      >
        <Summary.Item label="Role">
          {!isNil(userRole) && (
            <>
              <FieldLabel>{userRole.name}</FieldLabel>
              {userRole.description}
            </>
          )}
        </Summary.Item>
      </Summary.Section>
      <ButtonGroup>
        <Button variant={ButtonVariants.SECONDARY} onClick={handleCancel}>
          Cancel
        </Button>
        <ExecuteButton>Confirm and save</ExecuteButton>
      </ButtonGroup>
    </Card>
  );
};
